export default __webpack_public_path__ + "static/media/fastBackground2.6c46718e.mp3";